import useHookForm from '../../../../../../../hooks/forms/useHookForm'
import { validationSchema as schemaValidation } from './schema'
import { DEFAULT_VALUES } from './constants'
import { history } from '../../../../../../../utils/history'

import { getUserByEmail, getUserByCpf, createTutor, updateTutor } from '../../../../../../../services/user'

const useForm = ({ tutorWithoutEmail }) => {
  const handleValidateEmail = async ({ setTutor, setLoading, email }) => {
    try {
      setLoading(true)
      const req = await getUserByEmail(email)
      if (req[0] !== '') {
        setTutor(req[0])
      } else {
        setTutor()
        setLoading(false)
        return true
      }
      setLoading(false)
    } catch (error) {
      console.log('error', error)
      setLoading(false)
    }
  }

  const handleCreateTutor = async ({ payload, setLoading }) => {
    try {
      setLoading(true)
      const req = await createTutor(payload)
      if (req?.data.id) {
        history.push(`/vets/detalhes-do-tutor/${req.data.id}?alertContent=ACCOUNT_CREATED`)
        window.location.reload()
      }
      setLoading(false)
    } catch (error) {
      console.log('error', error)
      setLoading(false)
    }
  }

  const handleUpdateTutor = async ({ payload, id, setLoading, updated, setVisibility }) => {
    try {
      setLoading(true)
      const req = await updateTutor({ id, payload })
      if (req?.data.id) {
        updated(true)
        setVisibility(false)
      }
      setLoading(false)
    } catch (error) {
      console.log('error', error)
      setLoading(false)
    }
  }

  const onSubmitForm = (values, params) => {
    const { setTutor, setLoading, isEditing, id, updated, setVisibility } = params
    const { email, name, ...rest } = values
    const nameParts = name.split(' ')
    const firstName = nameParts[0]
    const lastName = nameParts.slice(1).join(' ')

    const payload = {
      firstName,
      lastName,
      email,
      ...rest
    }

    if (!isEditing) {
      const dontHaveEmail = handleValidateEmail({ setTutor, setLoading, email })

      if (dontHaveEmail) {
        handleCreateTutor({ payload, setLoading })
      }
    } else {
      handleUpdateTutor({ payload, id, setLoading, updated, setVisibility })
    }
  }

  const form = useHookForm({
    onSubmitForm,
    validationSchema: schemaValidation(tutorWithoutEmail),
    defaultValues: DEFAULT_VALUES
  })

  return form
}

export default useForm
